import { defineAction } from "rd-action-creators";

export const sendSignupAction = defineAction<{}>("SEND SIGNUP ACTION");

export const uploadMappingsForSignup = defineAction<{}>("UPLOAD MAPPINGS FOR SIGNUP");

export const changeStatusSignupModalAction = defineAction<{ isOpen: boolean }>("CHANGE STATUS SIGNUP MODAL ACTION");

export const changeSignupSendingFlag = defineAction<{ status: boolean }>("CHANGE SIGNUP SENDING FLAG ACTION");
